<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-input v-model="query.name" placeholder="business.label.name" @clear="refresh" @keydown.native.enter="refresh"/>
      </template>
      <template #extra>
        <vxe-button content="button.query" icon="vxe-icon-search" status="primary" @click="refresh"/>
        <vxe-button content="button.reset" icon="vxe-icon-undo" status="danger" @click="reset"/>
        <vxe-button content="button.add" icon="vxe-icon-add" status="primary" @click="add"/>
      </template>
      <vxe-table ref="table" :data="data" :loading="loading">
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="name" title="business.label.name" width="200"/>
        <vxe-column field="value" title="business.label.parameterValue"/>
        <vxe-column field="enterprise.name" title="business.label.enterprise" width="100"/>
        <vxe-column field="warehouse.name" title="business.label.warehouse" width="100"/>
        <vxe-column field="notes" title="business.label.parameterNote" width="300"/>
        <vxe-column :cell-render="{name:'VxeSwitch',props:{disabled:true}}" field="customized" title="business.label.customized" width="60"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.edit" icon="vxe-icon-edit" status="primary" @click.stop="edit(row,false)"/>
            <vxe-button content="button.copy" icon="vxe-icon-copy" status="primary" @click.stop="edit(row,true)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
      <template #footer>
        <vxe-pager :current-page="page" :loading="loading" :page-size="size" :total="contentSize" @page-change="pageChange"/>
      </template>
    </vxe-card>
    <parameter-editor ref="editor" @success="refresh"/>
  </div>
</template>

<script>
import { findAll } from '@/api/Api'
import { Parameter } from '@/api/dto/admin/Parameter'
import ParameterEditor from '@/views/config/parameter/ParameterEditor.vue'

export default {
  name: 'SystemParametersConfig',
  components: { ParameterEditor },
  data() {
    return {
      loading: false,
      data: [],
      query: new Parameter(),
      page: 1,
      size: 20,
      contentSize: 0
    }
  },
  activated() {
    this.refresh()
  },
  methods: {
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.fetch()
    },
    fetch() {
      this.loading = true
      findAll('parameterFactory', this.query.toJSONObject(), this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
        }
      }).finally(() => this.loading = false)
    },
    refresh() {
      this.page = 1
      this.fetch()
    },
    reset() {
      this.query = new Parameter(item)
      this.refresh()
    },
    add() {
      this.$refs.editor.add()
    },
    edit(row, copy) {
      this.$refs.editor.edit(row.id, copy)
    }
  }
}
</script>